import { useEffect, useState, useRef } from "react";
import styles from "./PricePeriodsGrid.module.css";
import moment from "moment";
import axios from "axios";

const PricePeriodsGrid = (props) => {
    const currentYear = moment().year();
    const years = Array.from({ length: 6 }, (_, i) => currentYear + i);
    const months = [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
    ];

    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedDates, setSelectedDates] = useState([]);

    const [state, setState] = useState({
        isSelecting: false,
        startX: 0,
        startY: 0,
        deleted: false,
    });

    const getDaysInMonth = (year, monthIndex) => {
        return new Date(year, monthIndex + 1, 0).getDate();
    };

    useEffect(() => {
        props.setPickedRate(props.baseBars[0]);
    }, []);

    const handleMouseDown = (event, date, isDel) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            isSelecting: true,
            startX: event.clientX,
            startY: event.clientY,
            deleted: isDel,
        }));
        if (!state.isSelecting) {
            setSelectedDates((prevSelectedDates) => {
                if (!prevSelectedDates.includes(date)) {
                    return [...prevSelectedDates, date];
                } else {
                    return prevSelectedDates.filter(
                        (selectedDate) => selectedDate !== date,
                    );
                }
            });
        }
    };

    //отпустили кнопку мыши остановили мультивыбор
    const handleMouseUp = () => {
        setState((prevState) => ({
            ...prevState,
            isSelecting: false,
        }));
    };

    //ушли за границу календаря - имитируем отпускание кнопки мыши
    const handleMouseLeave = () => {
        setState((prevState) => ({
            ...prevState,
            isSelecting: false,
        }));
    };

    //мультивыбор дат в календаре, при зажатой кнопке мыши
    const handleMouseMove = (event) => {
        if (!state.isSelecting) return;

        document.querySelectorAll(".price_cell").forEach((item) => {
            const rect = item.getBoundingClientRect();
            if (
                Math.min(state.startX, event.clientX) !== 0 &&
                Math.min(state.startY, event.clientY) !== 0 &&
                rect.left <= Math.max(state.startX, event.clientX) &&
                rect.top <= Math.max(state.startY, event.clientY) &&
                rect.right >= Math.min(state.startX, event.clientX) &&
                rect.bottom >= Math.min(state.startY, event.clientY)
            ) {
                const itemDate = item.getAttribute("data-id");

                if (state.deleted) {
                    setSelectedDates((pr) =>
                        pr.filter((selectedDate) => selectedDate !== itemDate),
                    );
                } else {
                    if (!selectedDates.includes(itemDate)) {
                        setSelectedDates((pr) => [...pr, itemDate]);
                    }
                }
            }
        });
    };

    const handleStateBar = (barId) => {
        props.setLoading(true);

        const uniqueDates = [...new Set(selectedDates)];
        axios
            .post(`/manager/data/hotels/${props.hotelId}/price_periods`, {
                barId,
                pickedRate: props.pickedRate.id,
                selectedDates: uniqueDates,
            })
            .then((response) => {
                setSelectedDates([]);
                props.getAllItems();
                props.setLoading(false);
                alert(response?.data?.message);
            })
            .catch((error) => {
                props.setLoading(false);
                console.error("Error PricePeriods", error);
            });
    };

    return (
        <>
            {selectedDates.length > 0 &&
                props?.bars[props?.pickedRate?.id]?.length > 0 && (
                    <div className={styles.barContainer}>
                        <div className={styles.barHeader}>
                            <div className={styles.barTitle}>Выберите BAR</div>
                            <button
                                className={styles.clearButton}
                                onClick={() => setSelectedDates([])}
                            >
                                ✖
                            </button>
                        </div>
                        <div className={styles.barButtons}>
                            {(props?.bars[props?.pickedRate?.id] ?? [])
                                .slice()
                                .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                                .map((bar) => (
                                    <button
                                        key={bar.code}
                                        className={styles.barButton}
                                        style={{
                                            backgroundColor: bar.color_bar,
                                        }}
                                        title={bar.name}
                                        onClick={() => handleStateBar(bar.id)}
                                    >
                                        {bar.code}
                                    </button>
                                ))}
                        </div>
                    </div>
                )}

            <div
                className={styles.container}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
            >
                {/* Таблица годов */}
                <div className={styles.yearButtons}>
                    {years.map((year) => (
                        <button
                            key={year + "-" + props?.pickedRate?.id}
                            onClick={() => setSelectedYear(year)}
                            className={`${styles.yearButton} ${selectedYear === year ? styles.active : ""}`}
                        >
                            {year}
                        </button>
                    ))}
                </div>

                {/* Таблица */}
                <div className={styles.tableWrapper}>
                    <table className={styles.table}>
                        {/* Заголовок (месяцы) */}
                        <thead>
                            <tr>
                                <th className={styles.tableHeader}></th>
                                {months.map((month, i) => (
                                    <th
                                        key={i + "-" + props?.pickedRate?.id}
                                        className={styles.tableHeaderCell}
                                    >
                                        {month}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        {/* Даты по вертикали + сетка */}
                        <tbody>
                            {Array.from({ length: 31 }, (_, dayIndex) => {
                                const day = dayIndex + 1;
                                const hasAtLeastOneDay = months.some(
                                    (_, monthIndex) =>
                                        day <=
                                        getDaysInMonth(
                                            selectedYear,
                                            monthIndex,
                                        ),
                                );
                                return hasAtLeastOneDay ? (
                                    <tr key={day}>
                                        {/* Число слева */}
                                        <td className={styles.dayCell}>
                                            {day < 10 ? `0${day}` : day}
                                        </td>

                                        {/* Ячейки с барами */}
                                        {months.map((_, monthIndex) => {
                                            const daysInMonth = getDaysInMonth(
                                                selectedYear,
                                                monthIndex,
                                            );
                                            if (day > daysInMonth)
                                                return (
                                                    <td
                                                        key={`${selectedYear}-${monthIndex + 1}-${day}`}
                                                    ></td>
                                                );

                                            const dateKey = moment({
                                                year: selectedYear,
                                                month: monthIndex,
                                                day,
                                            }).format("YYYY-MM-DD");

                                            const includesDates =
                                                selectedDates.includes(dateKey);

                                            const idBar =
                                                props.barPrices?.[
                                                    props.pickedRate?.id
                                                ]?.[dateKey] || null;

                                            const price =
                                                props.childBars[idBar]?.code ||
                                                null;
                                            const isSelected =
                                                selectedDates.includes(dateKey);

                                            return (
                                                <td
                                                    key={
                                                        dateKey +
                                                        props.barPrices?.[
                                                            props.pickedRate?.id
                                                        ]?.[dateKey]
                                                    }
                                                    data-id={dateKey}
                                                    onMouseDown={(e) =>
                                                        handleMouseDown(
                                                            e,
                                                            dateKey,
                                                            includesDates,
                                                        )
                                                    }
                                                    className={`price_cell ${styles.priceCell} ${isSelected ? styles.selected : ""}`}
                                                    style={{
                                                        backgroundColor:
                                                            props.childBars[
                                                                idBar
                                                            ]?.color_bar,
                                                    }}
                                                >
                                                    {price}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ) : null;
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default PricePeriodsGrid;
